export default __webpack_public_path__ + "static/media/n_wdt_c_3.4699fac4.mp3";